const config = {
    MAROPOST_IDENTITY_BASE_URL: "https://id-staging.maropost.com",
    UNIFICATION_SINGLE_URL: "https://accounts-staging.maropost.com",
    RAILS_BASE_URL: "https://staging-web.maropost.com",
    SERVICE_API_BASE_URL: "https://service-staging.maropost.com/api/v1/service",
    IDENTITY_JTI_COOKIE_NAME: '_mp_jti_staging',
    COOKIE_DOMAIN: '.maropost.local',
    IDENTITY_USER_PROFILE_COOKIE_NAME: '_mp_user_profile_staging',
    CONNECTOR_APP_RAILS_BASE_URL: 'https://staging-connector.maropost.com'
}

if (process.env.NODE_ENV === 'production') {
    const env = document.location.hostname.replace('.maropost.com', '')
    config.CONNECTOR_APP_RAILS_BASE_URL = 'https://connector.maropost.com'
    config.MAROPOST_IDENTITY_BASE_URL = "https://id.maropost.com"
    config.UNIFICATION_SINGLE_URL = "https://accounts.maropost.com"
    config.RAILS_BASE_URL= "https://app-web.maropost.com"
    config.SERVICE_API_BASE_URL = "https://servicecloud.maropost.com/api/v1/service"
    config.IDENTITY_JTI_COOKIE_NAME= '_mp_jti'
    config.COOKIE_DOMAIN = '.maropost.com'
    config.IDENTITY_USER_PROFILE_COOKIE_NAME= '_mp_user_profile'
    switch(env){
        case 'cloud':
            config.RAILS_BASE_URL = 'https://cloud-web.maropost.com'
        break
        case 'cloud1':
            config.RAILS_BASE_URL = 'https://cloud1-web.maropost.com'
        break
        case 'app-eu1':
            config.RAILS_BASE_URL = 'https://api-eu1.maropost.com'
        break
        case 'app-ca1':
            config.RAILS_BASE_URL = 'https://api-ca1.maropost.com'
        break
        case 'sandbox':
            config.RAILS_BASE_URL = 'https://sandbox-web.maropost.com'
            config.SERVICE_API_BASE_URL = "https://service-sandbox.maropost.com/api/v1/service"
            config.UNIFICATION_SINGLE_URL = "https://accounts-sandbox.maropost.com"
            config.CONNECTOR_APP_RAILS_BASE_URL = 'https://sandbox-connector.maropost.com'
        break
        case 'uat':
            config.RAILS_BASE_URL = 'https://uat-web.maropost.com'
            config.SERVICE_API_BASE_URL = "https://service-uat.maropost.com/api/v1/service"
            config.MAROPOST_IDENTITY_BASE_URL= "https://id-uat.maropost.com"
            config.UNIFICATION_SINGLE_URL = "https://accounts-uat.maropost.com"
            config.IDENTITY_JTI_COOKIE_NAME= '_mp_jti_staging'
            config.IDENTITY_USER_PROFILE_COOKIE_NAME= '_mp_user_profile_staging'
            config.CONNECTOR_APP_RAILS_BASE_URL = 'https://uat-connector.maropost.com'
        break
        case 'k8s':
            config.RAILS_BASE_URL = 'https://k8s-web.maropost.com'
        break
        case 'beta':
        case 'staging':
            config.RAILS_BASE_URL = 'https://staging-web.maropost.com'
            config.SERVICE_API_BASE_URL = "https://service-staging.maropost.com/api/v1/service"
            config.MAROPOST_IDENTITY_BASE_URL= "https://id-staging.maropost.com"
            config.UNIFICATION_SINGLE_URL = "https://accounts-staging.maropost.com"
            config.IDENTITY_JTI_COOKIE_NAME= '_mp_jti_staging'
            config.IDENTITY_USER_PROFILE_COOKIE_NAME= '_mp_user_profile_staging'
            config.CONNECTOR_APP_RAILS_BASE_URL = 'https://staging-connector.maropost.com'
        break
    }
}


export default config